import { ComponentColors, ThemeColor, ThemeFontWeight } from '@/enums'
import { propTypeFromEnumValues } from '@/utils'

export const themeColorPropType = propTypeFromEnumValues(ThemeColor)
export const themeFontWeightPropType = propTypeFromEnumValues(ThemeFontWeight)
export const componentColorPropType = propTypeFromEnumValues(ComponentColors)
